import type { AgentFocus } from '@tunasong/agent-context'

/**
 * What the composer's focus chip says (chat makeover #2718, C7). The builder's summary when it has one ("On Am7"),
 * otherwise the kind of element, never its raw id.
 */
export const focusChipLabel = (focus: Pick<AgentFocus, 'type' | 'summary' | 'sectionType'>): string => {
  if (focus.summary) {
    return `On ${focus.summary}`
  }
  if (focus.type === 'chord') {
    return 'On this chord'
  }
  if (focus.type === 'line') {
    return 'On this line'
  }
  if (focus.type === 'section' || focus.sectionType) {
    return 'On this section'
  }
  return 'On this block'
}
